<template>
  <div class="header-warp">
    <div class="header-box">
      <div class="module-title">
        <div class="content-center" style="display: flex;">
          <div class="iconfont icon-yupeicangdan-shanghai" />
          <div>{{ moduleTitle }}</div>
        </div>
      </div>
      <div class="header-right">
        <div class="balance-box">
          <span>当前余额：</span>
          <span class="balance-num">{{ account ? account.amount : 0 }}</span>
          <span>U币</span>
        </div>
        <div class="oper-box">
          <div class="oper-item oper-primary font-500 pl-40" @click="toTopUp">立即充值</div>
          <div class="oper-item oper-primary">
            <el-dropdown trigger="hover">
              <i class="iconfont icon-a-fuwuxieyifanwei" style="font-size:25px"></i>
              <el-dropdown-menu slot="dropdown" class="oper-menu-box">
                <el-dropdown-item @click.native="getServiceAgreement">服务协议</el-dropdown-item>
                <el-dropdown-item @click.native="getServiceScopeVisible">服务范围</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="oper-item">
            <i :class="searchShow ? 'iconfont icon-shouqi-shang' : 'iconfont icon-shouqi-xia' " @click="switchSearch" onselectstart="return false"></i>
          </div>
        </div>
      </div>
    </div>
    <div v-if="searchShow">
      <slot name="searchBox"></slot>
    </div>
    <ServiceAgreement v-if="serviceVisible" :visible.sync="serviceVisible" @closeDialog="closeDialog" />
    <ServiceScope :visible.sync="serviceScopeVisible" :serviceScopeData="serviceScopeData" @closeDialog="closeDialog" />

  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
import ServiceAgreement from './ServiceAgreement'
import ServiceScope from './ServiceScope'
import { scopecode } from './scopecode';

export default {
  name: "Header",
  components: {
    ServiceScope,
    ServiceAgreement,
  },
  props: {
    moduleTitle:String
  },
  data(){
    return{
      searchShow: true,
      account: null,
      serviceVisible: false,
      serviceScopeVisible: false,
      serviceScopeData: scopecode
    }
  },
  created(){
    this.getAccount()
  },
  methods:{
    // 打开服务协议
    getServiceAgreement(){
      this.serviceVisible = true
    },
    // 打开服务范围
    getServiceScopeVisible(){
      this.serviceScopeVisible = true
    },
    closeDialog(){
      this.serviceVisible = false
      this.serviceScopeVisible = false
      
    },
    // 充值
    toTopUp(){
      //window.location.href = '/user/finance/balance'
      this.$router.push({
        name:"balance",
      })
    },
    //收缩搜索条件
    switchSearch(){
      this.searchShow = !this.searchShow;
    },
    // 获取数据
    getAccount() {
      httpAjax({
        url: `/services/company/account`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          this.account = response.data;
        } else {
          this.$message({
            message: response.msg,
            type: 'error'
          })
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.header-warp {
  font-size: 14px;
  color: #333333;
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 10px;
  .icon-yupeicangdan-shanghai {
    font-size: 32px;
    margin-right: 16px !important;
    background: -webkit-linear-gradient(270deg, #f7f2fc 0%, #c9a7eb 100%);
    // background: -webkit-linear-gradient(left bottom, #f7f2fc 0%, #c9a7eb 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    // background: linear-gradient(180deg, #f7f2fc 0%, #c9a7eb 100%);
  }
  .pl-40 {
    padding-left: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .header-box {
    height: 60px;
    line-height: 60px;
    padding-left: 24px;
    background: #ffffff;
    border-radius: 4px;
    div {
      display: inline-block;
    }
    .module-title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
    }
    .header-right {
      float: right;
      display: flex;
      height: 60px;
    }
    .balance-box {
      font-weight: 500;
      display: flex;
      align-items: center;
      .balance-num {
        color: #f58d0b;
        font-size: 20px;
        margin-right: 4px;
        position: relative;
        top: -2px;
      }
    }
    /deep/.el-link {
      vertical-align: top;
    }
  }
  .oper-box .icon-a-fuwuxieyifanwei {
    color: #333 !important;
    font-size: 32px !important;
  }

  .icon-a-fuwuxieyifanwei:hover {
    color: #1d73ff !important;
    font-size: 32px !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }

  .icon-shouqi-shang:hover {
    color: #1d73ff !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }
  .icon-shouqi-xia:hover {
    color: #1d73ff !important;
    background: #e7f0fd !important;
    border-radius: 4px;
  }

  .icon-shouqi-shang {
    font-size: 32px !important;
    color: #333 !important;
  }
  .icon-shouqi-xia {
    font-size: 32px !important;
    color: #333 !important;
  }
}
</style>
